import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { WContainer, Chip } from '@next-nx/shared-ui/atoms'
import { Page } from '@next-nx/shared-ui/organisms'
import styles from './Custom404Template.module.sass'
import ScenarioPalazziIllustration from '../../atoms/Icons/ScenarioPalazziIllustration'
import AutoIllustration from '../../atoms/Icons/AutoIllustration'


interface Props {
  pagina?: any
}

const Custom404Template = (props: Props) => {

  const { 
    pagina = {},
  } = props

  const t = useTrans()

  // FAKE? o fissi?
  const links = [
    { pk: 1, name: 'Torna alla Homepage', url: '/', },
    { pk: 2, name: 'Soluzioni per Privati', url: '/offerte/privati', },
    { pk: 3, name: 'Soluzioni per Business/P.Iva', url: '/offerte/aziende-e-partite-iva', },
    { pk: 4, name: 'Soluzioni per Flotte aziendali', url: '/flotte-aziendali', },
  ]

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <div className={styles.bg}>
        <WContainer>
          <div className={styles.content}>
            <p className={styles.code}>{t("Codice errore: {0}", ['404'])}</p>
            <p className={styles.title}>{t("La pagina che stavi cercando non è stata trovata")}</p>
            <div className={styles.links}>
              <p className={styles.linksTitle}>{t("Alcuni link utili per te:")}</p>
              <div className={styles.linksList}>
                {links.map((x, index) => (
                  <Chip key={index} variant="lg" url={x.url} label={x.name || ''} />
                ))}
              </div>
            </div>
          </div>
        </WContainer>
        <div className={styles.bottom}>
          <span className={styles.auto}>
            <AutoIllustration />
          </span>
          <div className={styles.bottomBg}>
            <ScenarioPalazziIllustration />
            <ScenarioPalazziIllustration />
            <ScenarioPalazziIllustration />
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Custom404Template
